<template>
<router-link to="/liberoalarm" tag="div" class="stoppuhr z50 pointer active">
  <div class="inner">
    <img class="img stopuhr_none" src="/static/assets/alle/Stoppuhr.png" />
    <img class="img stopuhr_alarm" src="/static/assets/alle/Stoppuhr_alarm.png" />
    <img class="img stopuhr_zeiger" v-bind:style="{ transform: 'rotate(' + getTimerwert + 'deg)' }" src="/static/assets/alle/Zeiger.png" />
  </div>
</router-link>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import { bus } from '@/main.js'
window.$ = window.jQuery = require('jquery')

export default {
  name: 'Stoppuhr',
  data () {
    return {
      who: 'Stoppuhr',
      retval: 0,
      abgelaufen: false,
      timerwert: 0
    }
  },
  computed: {
    /* nur wenn tatsächlich was abgelaufen ist, hier das läutsymbol anzeigen, sonst das normale */
    getAbgelaufen () {
      return window.abgelaufen && !window.noAlarm
    },
    getTimerwert () {
      return this.timerwert
    }
  },
  watch: {
    abgelaufen: function (oldval, newval) {
      console.log('abgelaufen', oldval, newval)
    },
    timerwert: function (oldval, newval) {
      console.log('timerwert', oldval, newval)
    }
  },
  methods: {
    setAbgelaufen (wert) {
      // console.log('setabgelaufen', wert)
      this.abgelaufen = wert
    },
    setTimerwert () {
      // console.log('setTimerwert start')
      var x = 0   
      if (window.noAlarm) {
        x = 0
      } else if (window.verweilt >= window.maxzeit) { 
        x = 360
      } else {
        // 1% = 0.27777777777778
        x = ((window.verweilt) / (window.maxzeit / 100)) / 0.27777777777778 
      } 
      // console.log('setTimerwert', x)
      this.timerwert = x
    }
  },
  mounted () {
    bus.$on('abgelaufenEvent', this.setAbgelaufen(true))
    bus.$on('updateTimer', this.setTimerwert)
  }
}
</script>

<style scoped>
/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

.stoppuhr {
  position: absolute;
  left: 250px;
  bottom: 30px;
}

.stopuhr_alarm {
  width: 96px;
  height: auto;
  position: absolute;
  left: 0px;
  bottom: 26px;
  display: none;
}

.stopuhr_none {
  display: block;
}

.stopuhr_alarm {
  display: none;
}

.abgelaufen_blur .stopuhr_alarm {
  display: block !important;
}

.abgelaufen_blur .stopuhr_none {
  display: none !important;
}

.stoppuhr .inner { position: relative;}
.stopuhr_none {position: absolute; bottom: 0px; left: 0px; transform-origin: 50% 90%; }
.stopuhr_alarm { position: absolute; bottom: 17px; left: -10px; }
.stopuhr_zeiger { position: absolute; bottom: 40px; left: 33px; transform-origin: 50% 90%; }

.stoppuhr.z50.pointer.active {
z-index: 100000000;
}
</style>



// WEBPACK FOOTER //
// src/components/Stoppuhr.vue